module.exports = __webpack_public_path__ + "img/arcos-c-img-8.bfad7273.jpg";